<template>
    <div>
        <div class="dataTile">{{$t('DataInfo.Overview')}}</div>    
        <LeftConentBottom ></LeftConentBottom>
        <div class="dataTile">{{$t('DataInfo.File')}}</div>    
        <LeftDataBottom ></LeftDataBottom>
    </div>
</template>

<script>
export default {
  components: {
         LeftConentBottom: () => import("./LeftConentBottom.vue"),
          LeftDataBottom: () => import("./LeftDataBottom.vue"),
  }
}
</script>

<style lang="scss" scoped>
    .dataTile{
        margin-top: 10px;
        height: 40px;
        background: #4165eb;
        line-height: 40px;
        padding-left: 20px;
        font-size: 18px;
        color: #fff;
        font-weight: 600;
        // margin-left: 20px;
    }
</style>